import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { TabView, TabPanel } from "primereact/tabview";
import NouvellesCat from "./categorie/nouvellesCat";
import RepondeurCat from "./categorie/repondeurCat";
import EncoursCat from "./categorie/encoursCat";
import TraitesCat from "./categorie/traitesCat";
import AbandonnesCat from "./categorie/abandonnesCat";
import ToutesCat from "./categorie/toutesCat";


export default function ZotSuivis() {
 
  return (
    <>
      <TabView>
        <TabPanel header="Nouvelles">
          <NouvellesCat />
        </TabPanel>

        <TabPanel header="Répondeur">
        <RepondeurCat />
        </TabPanel>

        <TabPanel header="En cours">
        <EncoursCat />  
        </TabPanel>

        <TabPanel header="Traités">
          <TraitesCat />
        </TabPanel>

        <TabPanel header="Abandonnés">
          <AbandonnesCat />
        </TabPanel>

        <TabPanel header="Toutes">
          <ToutesCat/>
        </TabPanel>
      </TabView>
    </>
  );
}
